import { NavigationBarProps } from './Props';
import { NavigationBar } from './NavigationBar';

export function NavigationMobilePopup(props: NavigationBarProps) {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-end items-center bg-base-disabled bg-opacity-50 z-50">
      <div className="h-full">
        <NavigationBar {...props} />
      </div>
    </div>
  );
}
